<template>
        <v-img
            :max-height="maxHeight"
            :max-width="maxWidth"
            :alt="alt"
            :title="alt"
            :contain="!cover"
            :cover="cover"
            :class="user_flag"
            :lazy-src="imgSrc(picture, 'xs', direction)"
            :src="imgSrc(picture, size, direction)"
            @click="clickPicture(link)"
            class="pic"
            aspect-ratio="1"
        >
        </v-img>
</template>

<script>
import imageMethods from '../../mixins/imageMethods'

export default {
    name: "ListingPicture",
    mixins: [imageMethods],
    props: [
        'picture', //picture model (obj)
        'alt', //usually the name of the movei (string)
        'link', //url where picture must link (string)
        'user_flag', //user flag of the picture
        'size', //the desired picture size
        'direction', //the desired picture direction
        'cover' //if want to use cover mode
    ],
    computed: {
        maxHeight(){

            switch(this.size){

                case "xs":
                    return 90;

                case "sm":
                    return 250;

                case "lg":
                    return 400;

                default:
                    return 300;
            }

        },
        maxWidth(){

            switch(this.size){

                case "xs":
                    return 30;

                default:
                    return 500;
            }

        }
    },
    methods: {
        clickPicture(link){

            if(link == 'dialog') this.$emit('openDialog', link)
                else
                if(link) this.$router.push(link)
        }
    }
}
</script>

<style scoped>
.no-picture {
    max-height: 200px;
    max-width: 500px;
    min-height: 80px;
    //background-color: slategrey;
}
</style>
